<template>
  <button type="button" class="button is-gray-medium no-print" @click.prevent="printPage">
      <span class="icon-print mr-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z" fill="#ffffff"/></svg>  
      </span> {{ $lang.translate('track.button.print')}}
  </button>
</template>

<script>
export default {
  methods: {
    printPage() {
      window.print()
    }
  }
}
</script>

<style scoped>
button {
  cursor: pointer;
}

.icon-print {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-print > span {
  max-height: 100%;
  max-width: 100%;
}
</style>